// ==============================|| OVERRIDES - TOOLTIP ||============================== //

export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.secondary.dark,
          p: '2px 8px',
          border: `1px solid ${theme.palette.secondary.darker}`,
          borderRadius: '4px',
        },
      },
    },
  }
}
